import React, { Fragment } from "react";
import Header from "../Components/Layout/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../Components/Layout/Footer";

const PrivacyPolicy = () => {
  return (
    <Fragment>
      <Container sx={{ py: 4 }}>
        <Typography variant="h3" component="h2" sx={{ textAlign: "center" }}>
          Privacy Policy
        </Typography>
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          22 March 2020 (Version 1)
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Contents
        </Typography>
        <Typography sx={{ fontWeight: "bold" }}>
          <ul style={{ listStyle: "decimal" }}>
            <li>About this policy</li>
            <li>About us</li>
            <li>How to contact us</li>
            <li>What types of data we hold about you</li>
            <li>How we obtain your data</li>
            <li>Who we disclose your data to</li>
            <li>Where we process your data</li>
            <li>Data security and preventing unauthorised access</li>
            <li>Cookies that we use</li>
            <li>Your rights</li>
            <li>Third Party Websites</li>
            <li>Changes to this policy</li>
            <li>Legal status of this policy</li>
            <li>Meaning of words we use in this policy</li>
          </ul>
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          1. About this policy
        </Typography>
        <Typography>
          This is the privacy policy of Faam Gallery, which sets out our policy
          in relation to data and information we collect and use in relation to
          our visitors, customers and members. We keep your data confidential
          (unless your data is supplied for the purpose of being viewed by
          others, such as forum posts), and only use it and share it as detailed
          in this privacy policy. We will comply with the Data Protection Act
          1998 and the General Data Protection Regulation (GDPR) (Regulation
          (EU) 2016/679) in relation to your data. We do not sell your data to
          third parties.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          2. About us
        </Typography>
        <Typography>
          We are a family ran Limited company registered in England and with
          company number 12179625, and our registered office is at 131 Percy
          Road, Twickenham, Whitton, London, England, United Kingdom, TW2 6HT.
          <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          3. How to contact us
        </Typography>
        <Typography>
          To contact us, please write to our principal office at Faam Gallery,
          131 Percy Road, Twickenham, Whitton, London, England, United Kingdom,
          TW2 6HT or e-mail us at faamgallery@gmail.com ​<br />
          <br />
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          4. What types of data we hold about you
        </Typography>
        <Typography>
          The data and information we hold and process about you when opening an
          account or purchasing artwork(s) consists of the following: ​<br />
          <br />
          a. Information about you:
          <ul>
            <li>Your name</li>
            <li>
              Your contact details, including address, telephone, mobile, fax,
              own website, and e-mail.
            </li>
            <li>
              Your account information, including each membership and other
              account you have registered for with us.
            </li>
            <li>
              Your account log-in details, including username and password.
            </li>
            <li>
              Your address book, including other shipping addresses that you
              provide.
            </li>
            ​
          </ul>
          b. Information relating to your orders
          <ul>
            <li> Your purchase transactions</li>
            <li> Your purchase orders</li>
            <li> Your payment information and payment history</li>
            <li> Order delivery, fulfilment and returns information.</li> 
          </ul>
          c. Your activity online
          <ul>
            <li>Your content</li>
            <li>
              Your professional artist information, including, but not limited
              to personal details, galleries, portrait, biography, exhibitions,
              awards, tuition, media, and subjects.
            </li>
            <li>
              Messages that you exchange with other members using any service
              provided by us.
            </li>
            <li>Any other content that you supply.</li>
          </ul>
          d. Administration Information
          <ul>
            <li>
              Communications between you and us, including queries, problems,
              support, and survey responses, and including via e-mails,
              web-forms, and telephone.
            </li>
          </ul>
          e. Technical information when you visit our website
          <ul>
            <li>
              IP address (a unique identifier allocated to your computer for
              your connection to the internet).
            </li>
            <li>
              Information relation to your use of our website, including where
              you visited our website from, and what pages you visit on our
              website.
            </li>
          </ul>
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          5. How we obtain your data
        </Typography>
        <Typography>
          We obtain your data through a variety of means, including: <br />
          <br />​ a. Forms you fill in / data you provide.
          <ul>
            <li>From forms which you complete and submit on our website</li>
            <li>From printed forms which you obtain from our website or us</li>
            <li>
              Data we collect face-to-face, or by means of e-mail or telephone
            </li>
          </ul>
          b. Other information you supply
          <ul>
            <li>
              From the data, information and images you post, upload or
              otherwise provide to our website, including our forum.
            </li>
            <li>
              From any other information you supply from time to time, including
              through telephone calls, emails and other communications between
              you and us.
            </li>
            <li>
              From any information supplied by other users of our site and other
              customers.
            </li>
          </ul>
          c. Generated Information
          <ul>
            <li>
              From information generated by us as a result of dealings,
              transactions and communications with you, including supplying any
              goods or services to you, providing the functionality of our
              website, operating competitions, and dealing with queries, support
              requests and complaints.
            </li>
          </ul>
          d. Technical Information
          <ul>
            <li>
              From information which is automatically supplied by your
              web-browser when you visit our website.
            </li>
            <li>
              From information recorded by our server when you view any page on
              our website.
            </li>
          </ul>
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          6. Data uses
        </Typography>
        <Typography>
          We use your data for the following operational purposes: ​ <br />
          <br />
          a. Operate and improve our website
          <ul>
            <li>To provide our website and its features and functionality.</li>
            <li>To analyse the performance of and improve our website.</li>
            <li>
              To keep you informed with status or other administrative notices.
            </li>
          </ul>
          b. Supply of goods and services
          <ul>
            <li>
              To perform each order from you for the supply of goods and
              services.
            </li>
            <li>To collect payments due from you.</li>
          </ul>
          c. Provision of membership accounts
          <ul>
            <li>
              To provide, administer and manage your accounts and the associated
              services included in those accounts.
            </li>
            <li>To collect payment of all account fees.</li>
            <li>To pay commission on sales to artists.</li>​
          </ul>
          d. General administration
          <ul>
            <li>To monitor our staff.</li>
            <li>
              To communicate with you for administrative and support purposes.
            </li>
            <li>To manage complaints, disputes and claims.</li>
            <li>To enforce our contracts and terms and bring claims.</li>
          </ul>
          e. Marketing e-mails and communications
          <br />
          We will also use your data to send you marketing materials and
          newsletters relating to our website, products, services and events,
          but only where you have consented to this through the appropriate
          setting in our website whist filling forums, and you have not
          withdrawn your consent. You may change your consent by contacting us.
          ​ <br />
          <br />
          f. Data we hold on you is done so on our secure computer servers. We
          hold this data to ensure that we are able to manage your account and
          provide details to you on previous purchases and your account
          preferences. If you require us to remove this information, please see
          section 11.​ <br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          7. Who we disclose your data to
        </Typography>
        <Typography>
          a. Our contractors and supplier
          <br />
          Where we use third parties to provide or supply any part of our
          website or any goods, services, events, insurance or other things, or
          to enforce or administer any contracts or terms, then we may provide
          your data to them as reasonably required for those purposes, including
          to the artists from whom work is purchased from, delivery agents,
          payment processors, and insurers.
          <br />
          <br />
          Your data may be held by them as data processor on our behalf, in
          which case we will remain the data controller, and your data will only
          be held and used by them on our behalf and in accordance with our
          instructions and this policy. Your data will also only be held or as
          long as it is required to undertake their services, after which time
          it will be securely removed from their systems.
          <br />
          <br />
          In some cases, your data may need to be provided to them to be used by
          them for their own purposes, as data controller, where this is
          reasonably necessary, for the purposes of provision of any goods,
          services, insurance, event etc. by them. In such case, they should
          inform you separately that they are holding your data as data
          controller.  <br />
          <br />
          b. Legal requirements
          <br />
          We may supply your data to a government authority where required to
          comply with a legal requirement, for the administration of justice, or
          where reasonably required to protect your vital interests.  <br />
          <br />
          c. Claims handling
          <br />
          We may disclose your identity to any third party who is making any
          claim against us in relation to any of your data that you have posted
          or uploaded to our website, including where it is claimed to breach
          their rights or privacy. ​<br />
          <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          8. Where we process your data
        </Typography>
        <Typography>
          We and our suppliers normally store and process your data in the
          United Kingdom or in Iran. <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          9. Data security and preventing unauthorised access
        </Typography>
        <Typography>
          a. Our security measures
          <br />
          We will take and use reasonable endeavours to ensure our suppliers
          take all reasonable steps and implement all reasonable measures, to
          keep your data secure and prevent unauthorised access to your data and
          to prevent accidental loss or damage to your data.
          <br />
          <br />
          b. Your passwords
          <br />
          You are responsible for keeping your username and password log-in
          details confidential and we would ask you not to share them with
          anyone.  <br />
          <br />
          c. Information Security Policy
          <br />
          All employees are responsible for ensuring confidentiality of
          sensitive information. Faam Gallery recognises the importance of
          information security. The primary purpose of our information security
          is the protection of services to members and customers, and the
          customer information we are supplied with. It is the company’s aim to
          ensure that customers have confidence in our information security and
          are safe in the knowledge that we are responsive to their security
          concerns. ​<br />
          <br />
          Faam Gallery will adhere to all the requirements of PCI DSS in
          protecting customer card details. Everyone within Faam Gallery has an
          important role to play and each member of staff has their own specific
          tasks and responsibilities. We expect our core behaviour of
          professionalism and customer focus to be reflected in our protection
          of customer information. We support staff efforts to secure
          information through policies, and staff training and awareness
          activities. ​<br />
          <br />
          This policy is subject to review annually to ensure that at a
          strategic level it addresses the evolving information security threats
          and objectives needed for the organisation to be successful. ​<br />
          <br />
          d. Payment Card Security
          <br />
          Faam Gallery process payment cards through Wix Payment Page verified
          by SSL secure shopping. The addressed payment provider works with
          payment gateways that offer the highest level of security
          certification (PCI DSS Level 1).​ <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          10. Cookies that we use
        </Typography>
        <Typography>
          Cookies are small text files which a web page can save on your
          computer and read at a later date. We use cookies only where necessary
          for the purposes of the technical operation of our website, including
          for managing log-ins, shopping baskets, transactions and other
          functions of our website. ​ <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          11. Your rights
        </Typography>
        <Typography>
          a. Access to your data
          <br />
          You can see most of your data through your account web pages when
          logged in on our website. Under the Data Protection Act 1998 and
          General Data Protection Regulation (GDPR) (Regulation (EU) 2016/679),
          you are entitled to a copy of all personal data we hold about you. If
          you would like to exercise this right, please contact us via email
          at faamgallery@gmail.com, requesting a Subject Access Request Form.
          <br />
          <br />
          b. Your right to stop marketing messages
          <br />
          If we are sending you marketing literature (including paper-based and
          electronic messages), you have the right to ask us to stop doing this.
          Please contact us using our contact details above.
          <br />
          <br />
          c. Your right to stop use causing distress
          <br />
          You have the right to ask us to stop using any data for any purpose
          where that purpose is causing you substantial distress. If you have
          any concerns regarding our use of your data, please contact us using
          our contact details in this policy.
          <br />
          <br />
          d. Your right to alter inaccurate data
          <br />
          You are entitled to ask us to change, erase, block or modify any
          inaccuracies in your personal data, by contacting us using our contact
          details above. We will respond to these requests within one month. In
          most cases you can do this yourself though your account web pages on
          our website, which let you change and update your data.
          <br />
          <br />
          e. Your right to revoke consent at any time
          <br />
          You have the right to withdraw consent for us to use your data at any
          time. If this withdrawal means we are not able to provide a service to
          you, we will advise of this at the time of withdrawal.
          <br />
          <br />
          f. Your right to erasure
          <br />
          If you wish to have all of your data that is held by Faam Gallery
          erased, you should contact us on the details above, to which we will
          respond within one month.
          <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          12. Third-Party Websites
        </Typography>
        <Typography>
          No waiver by us, in exercising any right, power or provision hereunder
          shall operate as a waiver of any other right or of that same right at
          a future time; nor shall any delay in exercise of any power or right
          be interpreted as a waiver.  <br /> <br />
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          13. Changes to this policy
        </Typography>
        <Typography>
          We may at any time change this privacy policy by publishing a new
          version on our website. We will not be required to inform you of this.
          You are responsible for regularly reviewing our website and stay up to
          date with the latest version of this policy. By continuing to use our
          website and services after any such change you will be considered to
          have accepted the change.  <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          14. Legal status of this policy
        </Typography>
        <Typography>
          This privacy policy is not intended to and does not create any
          contractual or other legal rights in or on behalf of any party other
          than such rights as already exist by law separately to this privacy
          policy.
          <br /> <br />
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", textDecoration: "underline" }}
        >
          15. Meaning of words we use in this policy
        </Typography>
        <Typography>
          In this policy:
          <ul>
            <li>
              personal data means any of your data which constitutes personal
              data under the Data Protection Act 1998 or General Data Protection
              Regulation (GDPR) (Regulation (EU) 2016/679), and in relation to
              which you are the data subject.
            </li>
            <li>
              we, our and us means Faam Gallery, trading as Faam Gallery Ltd.
            </li>
            <li>
              you and your means you our guest, visitor, customer or member,
              including anyone who visits our website, registers for an account
              with us, purchases anything from us, uses our website forum,
              enters any competition through our website, registers for a
              professional account and becomes a full member of ours, any
              affiliated club and its members and any regional co-ordinator.
            </li>
            <li>
              your data means all data and information which you supply, or we
              otherwise hold, obtain, generate or process in relation to you
              from time to time, as further detailed in this policy.
            </li>
            <li>
              service means any service provided by us, whether free or
              paid-for, including our website any service, feature or
              functionality of our website.
            </li>
            <li>
              website means our internet website whose address is
              https://www.faamgallery.com and any additional or replacement
              website from time to time that we operate.
            </li>
          </ul>
        </Typography>
      </Container>
    </Fragment>
  );
};

export default PrivacyPolicy;
